import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import React from "react";

import { AuditTrailList } from "./AuditTrailList";
import FullScreenLoading from "../common/loading/FullScreenLoading";
import FourohFour from "../home/FourohFour";
import PageTitle from "../layout/PageTitle";

const GET_USER_AUDIT_TRAIL = gql`
  query user {
    user {
      uuid
      auditTrail {
        uuid
        fileName
        createdAt
      }
    }
  }
`;

export function AuditTrailUser() {
  const { data, loading } = useQuery(GET_USER_AUDIT_TRAIL);

  if (!data && loading) {
    <FullScreenLoading loadingTrigger={loading} />;
  }

  if (!data) {
    return <FourohFour />;
  }
  return (
    <div>
      <PageTitle className="mb-6" title="All past revisions" />
      <AuditTrailList auditTrail={data?.user?.auditTrail} />
    </div>
  );
}
